import { useMemo } from 'react'

import { OnErrorProvider } from '@cash-web/shared-feature-error'
import { FlowContext, FlowContextProps } from '@cash-web/shared-flow-data-access-context'
import { OptionalMiddlewareContext, useOptionalFetchMiddleware } from '@cash-web/shared-util-fetch'

import { UseFlowResponse } from './hooks/useFlow'

export const FlowProvider = ({
  flow,
  children,
}: React.PropsWithChildren<{
  flow: UseFlowResponse
}>) => {
  const {
    logBlockerError,
    active,
    isInProgress,
    isLoading,
    error,
    startWithBlockerDescriptors,
    startWithClientScenario,
    startWithFlow,
    startWithResponse,
    complete,
    updateWithBlockerDescriptors,
    updateWithClientScenario,
    updateWithFlow,
    updateWithResponse,
    cancel,
    reset,
    restore,
    suspend,
    skipBlocker,
    optionalMiddleware,
    loadUrl,
    executeBlockerAction,
    closeBlockerAction,
  } = flow

  const flowContext: FlowContextProps = useMemo(() => {
    return {
      active,
      isInProgress,
      isLoading,
      error,
      complete,
      skipBlocker,
      startWithBlockerDescriptors,
      startWithClientScenario,
      startWithFlow,
      startWithResponse,
      updateWithBlockerDescriptors,
      updateWithClientScenario,
      updateWithFlow,
      updateWithResponse,
      cancel,
      reset,
      restore,
      suspend,
      loadUrl,
      executeBlockerAction,
      closeBlockerAction,
    }
  }, [
    active,
    isInProgress,
    isLoading,
    error,
    complete,
    skipBlocker,
    startWithBlockerDescriptors,
    startWithClientScenario,
    startWithFlow,
    startWithResponse,
    updateWithBlockerDescriptors,
    updateWithClientScenario,
    updateWithFlow,
    updateWithResponse,
    cancel,
    reset,
    restore,
    suspend,
    loadUrl,
    executeBlockerAction,
    closeBlockerAction,
  ])

  const middleware = useOptionalFetchMiddleware(optionalMiddleware)
  return (
    <OptionalMiddlewareContext.Provider value={middleware}>
      <FlowContext.Provider value={flowContext}>
        <OnErrorProvider onError={logBlockerError}>{children}</OnErrorProvider>
      </FlowContext.Provider>
    </OptionalMiddlewareContext.Provider>
  )
}
